import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-curorc',
  templateUrl: './curorc.component.html',
  styleUrls: ['./curorc.component.css']
})
export class CurorcComponent {
  isBrowser:boolean=false;
  baseUrl=Constants.baseUrl;

  constructor(
    private titleService: Title, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,private seoService:SeoService,
    private metaService: Meta , @Inject(PLATFORM_ID) private platformId: any,

  ) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
  {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mitresource.com/curorc/"
    },
    "headline": "CuroRC: Empowering rapid-paced Studios with Technology Intelligence",
    "description": "Learn how we built an all-in-one multi- faceted platform for CuroRc making it faster, convenient, more secure, and less expensive.",
    "image": "https://mitresource.com/assets/images/banners/curorcmobilebannar.png",  
    "author": {
      "@type": "Organization",
      "name": "Maganti IT Resources",
      "url": "https://mitresource.com/"
    },  
    "publisher": {
      "@type": "Organization",
      "name": "Maganti IT",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
      }
    },
    "datePublished": "2023-06-15"
  }`;
   
    this._renderer2.appendChild(this._document.head, script);
    
  

    if(this.isBrowser){     
  AOS.init({disable: 'mobile'});
}
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Transform into a Data-Driven Organization');

    this.metaService.addTags([
      { name: 'description', content: 'CuroRC is all in one Class Management Software Solution for Studios and Associations offering multi-faceted platform!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Transform into a Data-Driven Organization' },
      { property: 'og:url', content: 'https://mitresource.com/curoRc/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/curorcimages/selfservice.png' },
      { property: 'og:description', content: 'CuroRC is all in one Class Management Software Solution for Studios and Associations offering multi-faceted platform.' },
    ]);
  }
}
